export { default } from './GrownUpReview';



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductReviewList/GrownUpReview/index.js